import React, { useState } from 'react'
import { Modal, ModalBody } from "react-bootstrap";
import ModalHeader from '../../../../../../../../Setup/Shared/ModalHeader';

const PrintOutSelectDataModal = ({ printoutSelectDataModal, setPrintoutSelectDataModal, setPrintoutModal, selectedItems, setSelectedItems, ...props }) => {
    let { showAddressTypeLocation, setShowAddressTypeLocation, id} = props;
    const { insertPosition= '' } = props;
    const customTemplateClinicalExist = (insertPosition === 'Top' || insertPosition === 'Bottom') && props?.customTemplateData?.length > 0;
    const checklistStructure = {
        ...(customTemplateClinicalExist ? { "customTemplateClinical": [] } : {}),
        'patientSummary': [] ,
        'chiefComplaint': [] ,
        'historyofPresentIllness': [] ,
        'reviewOfSystem': [] ,
        'problems': [],
        'behaviourNotes': [],
        'interventionNotes': [],
        'responseNotes': [],
        // 'planNotes': [],
        'plan': [ "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging", "planNotes", "followUp"],
        'additionalInfo': ["documents", "additionalNotes"],
        'procedureCodes':[]
    };


    const getParentKey = (childKey) => {
        for (const [parent, children] of Object.entries(checklistStructure)) {
            if (children.includes(childKey)) return parent;
        }
        return null;
    };

    const toggleItem = (key) => {
        setSelectedItems((prev) => {
            const updated = { ...prev };
            const isNowChecked = !prev[key];

            // 1. Check if it's a parent
            if (checklistStructure[key]) {
                // Parent toggle: set parent and all children
                updated[key] = isNowChecked;
                checklistStructure[key].forEach((child) => {
                    updated[child] = isNowChecked;
                });
            } 
            else {
                // 2. It's a child toggle
                updated[key] = isNowChecked;

                const parent = getParentKey(key);
                if (parent) {
                    const allChildren = checklistStructure[parent];
                    const allChecked = allChildren.every((c) =>
                        c === key ? isNowChecked : prev[c]
                    );
                    updated[parent] = allChecked;
                }
            }

            return updated;
        });
    };

    const allKeys = [
        "patientSummary",
        ...(customTemplateClinicalExist ? ['customTemplateClinical'] : []),
        "chiefComplaint",
        "historyofPresentIllness", 
        "reviewOfSystem",
        "problems",
        "behaviourNotes",
        "interventionNotes",
        "responseNotes",
        "plan",
        "prescriptions", "supplements", "vaccines", "injections", "labs", "imaging",
        "planNotes",
        "followUp",
        "additionalInfo",
        "documents",
        "additionalNotes",
        "procedureCodes",
    ];

    const selectAll = () => {

        const allChecked = allKeys.reduce((acc, key) => {
            acc[key] = true;
            return acc;
        }, {});

        setSelectedItems(prev => ({ ...allChecked, uiDesign : prev.uiDesign ?? false}));
    };

    // Optional: for Proceed button
    const handleProceed = () => {
        const selected = Object.entries(selectedItems)
            .filter(([_, val]) => val)
            .map(([key]) => key);

        console.log("Selected Items:", selected);
        // pass `selected` to next modal

        // const allUnChecked = allKeys.reduce((acc, key) => {
        // acc[key] = false;
        // return acc;
        // }, {});
        // setSelectedItems(allUnChecked);

        setPrintoutModal(true);
        setPrintoutSelectDataModal(false);
    };

    const EncounterName = () => {
        return (
            <p className="heading">Print Encounter Summary</p>
        )
    }

    return (
        <>
            <Modal show={printoutSelectDataModal} onHide={printoutSelectDataModal} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_print_encounter_summary">
                <Modal.Body>
                    <ModalHeader HeaderName={EncounterName} DeletePopup={''} isClosed={() => setPrintoutSelectDataModal(false)} />
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <p className="heading">Select Encounter data to print</p>
                            <p
                                className="heading validate-color cursor-pointer user-select-none"
                                onClick={selectAll}
                            >
                                Select All
                            </p>
                        </div>

                        <div className="d-flex gap-15">
                            <div className="w-50 d-flex flex-column row-gap-12 za_br_light br-right-1">
                                {/* Patient Summary */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["patientSummary"]}
                                                onChange={() => toggleItem("patientSummary")}
                                            />
                                        </div>
                                        <p className="text fs-13">Patient Address</p>
                                    </label>
                                    {!!selectedItems["patientSummary"] ? 
                                    <div className="child d-flex flex-column gap-2">
                                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                            type="radio"
                                            id={`address-false-${id}`}
                                            name={`ShowPatientsData-${id}`}
                                            value="false"
                                            checked={showAddressTypeLocation === 'false'}
                                            onChange={(e) => setShowAddressTypeLocation(e.target.value)}
                                            />
                                            <label className="text ar-orange-text text-nowrap" htmlFor={`address-false-${id}`}>Patient Address</label>
                                        </div>
                                        <div className="ar_radio-btn d-flex align-items-center gap-6">
                                            <input
                                            type="radio"
                                            id={`address-true-${id}`}
                                            name={`ShowPatientsData-${id}`}
                                            value="true"
                                            checked={showAddressTypeLocation === 'true'}
                                            onChange={(e) => setShowAddressTypeLocation(e.target.value)} 
                                            />
                                            <label className="text ar-orange-text text-nowrap" htmlFor={`address-true-${id}`}>Location Address</label>
                                        </div>
                                    </div> : <></>}
                                </div>

                                {/* Custom Template Clinical */}
                                {(customTemplateClinicalExist && insertPosition === 'Top') ?
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">{props?.customTemplateData?.[0]?.TemplateName || "Custom Template Clinical"}</p>
                                    </label>
                                </div> : <></>}
                                {/* Subjective */}
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["chiefComplaint"]}
                                                    onChange={() => toggleItem("chiefComplaint")}
                                                />
                                            </div>
                                            <p className="text fs-13">Chief Complaint</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["historyofPresentIllness"]}
                                                    onChange={() => toggleItem("historyofPresentIllness")}
                                                />
                                            </div>
                                            <p className="text fs-13">History of Present Illness</p>
                                        </label>
                                </div>
                                <div className="d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["reviewOfSystem"]}
                                                    onChange={() => toggleItem("reviewOfSystem")}
                                                />
                                            </div>
                                            <p className="text fs-13">Review Of System</p>
                                        </label>
                                </div>

                                {/* Problems */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["problems"]}
                                                onChange={() => toggleItem("problems")}
                                            />
                                        </div>
                                        <p className="text fs-13">Problems</p>
                                    </label>
                                    {/* <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["problems"]}
                                                    onChange={() => toggleItem("problems")}
                                                />
                                            </div>
                                            <p className="text fs-13">Problems</p>
                                        </label>
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["assessmentNotes"]}
                                                    onChange={() => toggleItem("assessmentNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div> */}
                                </div>
                                {/* Behaviour */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["behaviourNotes"]}
                                            onChange={() => toggleItem("behaviourNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Behaviour</p>
                                </label>
                                {/* Intervention */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["interventionNotes"]}
                                            onChange={() => toggleItem("interventionNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Intervention</p>
                                </label>
                                {/* Response */}
                                <label className="d-flex align-items-center gap-6 user-select-none">
                                    <div className="custom_check_box d-flex">
                                        <input
                                            type="checkbox"
                                            className="form-check-input m-0 p-0"
                                            checked={!!selectedItems["responseNotes"]}
                                            onChange={() => toggleItem("responseNotes")}
                                        />
                                    </div>
                                    <p className="text fs-13">Response</p>
                                </label>
                            </div>
                            {/* Right Column */}
                            <div className="d-flex flex-column row-gap-12">
                                {/* Plan */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["plan"]}
                                                onChange={() => toggleItem("plan")}
                                            />
                                        </div>
                                        <p className="text fs-13">Plan</p>
                                    </label>
                                    
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["prescriptions"]}
                                                    onChange={() => toggleItem("prescriptions")}
                                                />
                                            </div>
                                            <p className="text fs-13">Prescriptions</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["supplements"]}
                                                    onChange={() => toggleItem("supplements")}
                                                />
                                            </div>
                                            <p className="text fs-13">Supplements</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["vaccines"]}
                                                    onChange={() => toggleItem("vaccines")}
                                                />
                                            </div>
                                            <p className="text fs-13">Vaccines</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["injections"]}
                                                    onChange={() => toggleItem("injections")}
                                                />
                                            </div>
                                            <p className="text fs-13">Injections</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["labs"]}
                                                    onChange={() => toggleItem("labs")}
                                                />
                                            </div>
                                            <p className="text fs-13">Labs</p>
                                        </label>
                                    </div>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["imaging"]}
                                                    onChange={() => toggleItem("imaging")}
                                                />
                                            </div>
                                            <p className="text fs-13">Imaging</p>
                                        </label>
                                    </div>

                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["planNotes"]}
                                                    onChange={() => toggleItem("planNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                    
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["followUp"]}
                                                    onChange={() => toggleItem("followUp")}
                                                />
                                            </div>
                                            <p className="text fs-13">Follow-Up</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Custom Template Clinical */}
                                {(customTemplateClinicalExist && insertPosition === 'Bottom') ?
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["customTemplateClinical"]}
                                                onChange={() => toggleItem("customTemplateClinical")}
                                            />
                                        </div>
                                        <p className="text fs-13">{props?.customTemplateData?.[0]?.TemplateName || "Custom Template Clinical"}</p>
                                    </label>
                                </div> : <></>}
                                {/* Additional Info */}
                                <div className="d-flex flex-column gap-2">
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["additionalInfo"]}
                                                onChange={() => toggleItem("additionalInfo")}
                                            />
                                        </div>
                                        <p className="text fs-13">Additional Info</p>
                                    </label>
                                    <div className="child d-flex flex-column gap-2">
                                        <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["documents"]}
                                                    onChange={() => toggleItem("documents")}
                                                />
                                            </div>
                                            <p className="text fs-13">Documents</p>
                                        </label>
                                         <label className="d-flex align-items-center gap-6 user-select-none">
                                            <div className="custom_check_box d-flex">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input m-0 p-0"
                                                    checked={!!selectedItems["additionalNotes"]}
                                                    onChange={() => toggleItem("additionalNotes")}
                                                />
                                            </div>
                                            <p className="text fs-13">Notes</p>
                                        </label>
                                    </div>
                                </div>

                                {/* Procedure Codes */}
                                <div>
                                    <label className="d-flex align-items-center gap-6 user-select-none">
                                        <div className="custom_check_box d-flex">
                                            <input
                                                type="checkbox"
                                                className="form-check-input m-0 p-0"
                                                checked={!!selectedItems["procedureCodes"]}
                                                onChange={() => toggleItem("procedureCodes")}
                                            />
                                        </div>
                                        <p className="text fs-13">Procedure Codes</p>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </>
                </Modal.Body>
                <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light ar_footer justify-content-between">
                    <div>
                        <label className="d-flex align-items-center gap-6 user-select-none">
                            <div className="custom_check_box d-flex">
                                <input
                                    type="checkbox"
                                    className="form-check-input m-0 p-0"
                                    checked={!!selectedItems["uiDesign"]}
                                    onChange={() => toggleItem("uiDesign")}
                                />
                            </div>
                            <p className="text fs-13">Black and White</p>
                        </label>
                    </div>
                    <div className="btns-group">
                        <button className="btn btn-validate px-10 h-100 d-flex align-items-center gap-1" onClick={handleProceed}>
                            Proceed
                            <i className="icon-Symbol-24--25 text-white fs-12"></i>
                        </button>
                    </div>
                </div>

            </Modal>
        </>
    )
}

export default PrintOutSelectDataModal